import { getPartnerAdAccountsUrl } from '@lib/utils/url';

export function AccountDataController($state, $scope) {
  'ngInject';
  const vm = this;

  vm.hrefs = {
    companyDetails: $state.href('accountSettings.account-data.company-details'),
    userDetails: $state.href('accountSettings.account-data.user-details'),
    users: $state.href('accountSettings.users'),
    invoices: $state.href('accountSettings.invoices'),
    paymentMethod: $state.href('accountSettings.account-data.payment-method'),
    partnerAdAccounts: getPartnerAdAccountsUrl(),
    ssoConfiguration: $state.href('accountSettings.account-data.sso-configuration'),
    twoFactorConfiguration: $state.href('accountSettings.account-data.two-factor-authentication'),
    accountHistory: $state.href('accountSettings.account-history'),
  };

  vm.goToAccountData = _goToAccountData;

  $scope.$emit('account-settings:active', 'account-data');

  /**
   * Go to apps route when right panel is closed
   */
  function _goToAccountData() {
    $state.go('accountSettings.account-data');
  }
}
